jQuery(document).ready(function ($) {
  // image alt
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\..+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  // breadcrumbs
  $('ul.breadcrumb').prepend('<li><a href="/">Home</a></li>');

  //View More for Directory
  $('.bio-content-toggle').click(function () {
    var $bio = $(this).parent();
    var $toggletext = $(this).children('.text');

    if ($bio.hasClass('expanded')) {
      $bio.removeClass('expanded');
      $toggletext.text("View More");
    } else {
      $bio.addClass('expanded');
      $toggletext.text("View Less");
    }
  });

  $('.bio-content-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      var $bio = $(this).parent();
      var $toggletext = $(this).children('.text');

      if ($bio.hasClass('expanded')) {
        $bio.removeClass('expanded');
        $toggletext.text("View More");
      } else {
        $bio.addClass('expanded');
        $toggletext.text("View Less");
      }
    }
  });

  // cost calculator
  function costCalculator() {
    var tuition = parseFloat('9650');
    // var student1 = $('input[name="student1"]');
    var student1Discount;
    var student1Tuition;
    // var student2 = $('input[name="student2"]');
    var student2Discount;
    var student2Tuition;
    // var student3 = $('input[name="student3"]');
    var student3Discount;
    var student3Tuition;
    // var student4 = $('input[name="student4"]');
    var student4Discount;
    var student4Tuition;

    // convert to dollars
    students();

    $('.cost-calculator select, .cost-calculator input[type="radio"]').on('change', function () {
      attendingSHGDiscount = parseFloat($('#attendingSHG').find(':selected').attr('data-value'));
      if (attendingSHGDiscount === 1000) {
        student1Discount1 = 0;
        student2Discount1 = 1000;
        student3Discount1 = 0;
        student4Discount1 = 0;
        if (!$('.student2').is(':visible')) {
          $('.student2').fadeIn(350).prev('label').fadeIn(350);
        }
        if ($('.student3').is(':visible')) {
          $('.student3').fadeOut(350).prev('label').fadeOut(350);
        }
        if ($('.student4').is(':visible')) {
          $('.student4').fadeOut(350).prev('label').fadeOut(350);
        }
        $('.results').css('opacity', '1');
      } else if (attendingSHGDiscount === 2000) {
        student1Discount1 = 0;
        student2Discount1 = 1000;
        student3Discount1 = 2000;
        student4Discount1 = 0;
        if (!$('.student2').is(':visible')) {
          $('.student2').fadeIn(350).prev('label').fadeIn(350);
        }
        if (!$('.student3').is(':visible')) {
          $('.student3').fadeIn(350).prev('label').fadeIn(350);
        }
        if ($('.student4').is(':visible')) {
          $('.student4').fadeOut(350).prev('label').fadeOut(350);
        }
        $('.results').css('opacity', '1');
      } else if (attendingSHGDiscount === 9650) {
        student1Discount1 = 0;
        student2Discount1 = 1000;
        student3Discount1 = 2000;
        student4Discount1 = 9650;
        if (!$('.student2').is(':visible')) {
          $('.student2').fadeIn(350).prev('label').fadeIn(350);
        }
        if (!$('.student3').is(':visible')) {
          $('.student3').fadeIn(350).prev('label').fadeIn(350);
        }
        if (!$('.student4').is(':visible')) {
          $('.student4').fadeIn(350).prev('label').fadeIn(350);
        }
        $('.results').css('opacity', '1');
      } else {
        student1Discount1 = 0;
        student2Discount1 = 0;
        student3Discount1 = 0;
        student4Discount1 = 0;
        if ($('.student2').is(':visible')) {
          $('.student2').fadeOut(350).prev('label').fadeOut(350);
        }
        if ($('.student3').is(':visible')) {
          $('.student3').fadeOut(350).prev('label').fadeOut(350);
        }
        if ($('.student4').is(':visible')) {
          $('.student4').fadeOut(350).prev('label').fadeOut(350);
        }
        $('.results').css('opacity', '1');
      }

      attendingSCGSDiscount = parseFloat($('#attendingSCGS').find(':selected').attr('data-value'));
      if (attendingSCGSDiscount === 500) {
        student1Discount2 = 500;
        student2Discount2 = 500;
        student3Discount2 = 500;
        student4Discount2 = 500;
      } else if (attendingSCGSDiscount === 1000) {
        student1Discount2 = 1000;
        student2Discount2 = 1000;
        student3Discount2 = 1000;
        student4Discount2 = 1000;
      } else if (attendingSCGSDiscount === 1500) {
        student1Discount2 = 1500;
        student2Discount2 = 1500;
        student3Discount2 = 1500;
        student4Discount2 = 1500;
      } else if (attendingSCGSDiscount === 2000) {
        student1Discount2 = 2000;
        student2Discount2 = 2000;
        student3Discount2 = 2000;
        student4Discount2 = 2000;
      } else {
        student1Discount2 = 0;
        student2Discount2 = 0;
        student3Discount2 = 0;
        student4Discount2 = 0;
      }

      cgsDiscount = parseFloat($('input[name="cgs"]:checked').attr('data-value'));
      if (cgsDiscount === 1000) {
        student1Discount3 = 1000;
        student2Discount3 = 1000;
        student3Discount3 = 1000;
        student4Discount3 = 0;
      } else {
        student1Discount3 = 0;
        student2Discount3 = 0;
        student3Discount3 = 0;
        student4Discount3 = 0;
      }

      paymentDiscount = parseFloat($('#paymentPlan').find(':selected').attr('data-value'));
      if (paymentDiscount === 50) {
        student1Discount4 = 50;
        student2Discount4 = 50;
        student3Discount4 = 50;
        student4Discount4 = 50;
      } else if (paymentDiscount === 100) {
        student1Discount4 = 100;
        student2Discount4 = 100;
        student3Discount4 = 100;
        student4Discount4 = 100;
      } else {
        student1Discount4 = 0;
        student2Discount4 = 0;
        student3Discount4 = 0;
        student4Discount4 = 0;
      }

      incomeDiscount = parseFloat($('#income').find(':selected').attr('data-value'));
      if (incomeDiscount === 3500) {
        student1Discount5 = 3500;
        student2Discount5 = 3500;
        student3Discount5 = 3500;
        student4Discount5 = 3500;
      } else if (incomeDiscount === 3000) {
        student1Discount5 = 3000;
        student2Discount5 = 3000;
        student3Discount5 = 3000;
        student4Discount5 = 3000;
      } else if (incomeDiscount === 2500) {
        student1Discount5 = 2500;
        student2Discount5 = 2500;
        student3Discount5 = 2500;
        student4Discount5 = 2500;
      } else if (incomeDiscount === 2000) {
        student1Discount5 = 2000;
        student2Discount5 = 2000;
        student3Discount5 = 2000;
        student4Discount5 = 2000;
      } else if (incomeDiscount === 1500) {
        student1Discount5 = 1500;
        student2Discount5 = 1500;
        student3Discount5 = 1500;
        student4Discount5 = 1500;
      } else if (incomeDiscount === 1000) {
        student1Discount5 = 1000;
        student2Discount5 = 1000;
        student3Discount5 = 1000;
        student4Discount5 = 1000;
      } else {
        student1Discount5 = 0;
        student2Discount5 = 0;
        student3Discount5 = 0;
        student4Discount5 = 0;
      }

      student1DiscountTotal = student1Discount1 + student1Discount2 + student1Discount3 + student1Discount4 + student1Discount5;
      student1Tuition = tuition - student1DiscountTotal;
      student1DiscountTotal1 = student1Discount1;
      student1DiscountTotal2 = student1Discount1 + student1Discount2;
      student1DiscountTotal3 = student1Discount1 + student1Discount2 + student1Discount3;
      student1DiscountTotal4 = student1Discount1 + student1Discount2 + student1Discount3 + student1Discount4;
      student1DiscountTotal5 = student1Discount1 + student1Discount2 + student1Discount3 + student1Discount4 + student1Discount5;
      student1Tuition1 = tuition - student1DiscountTotal1;
      student1Tuition2 = tuition - student1DiscountTotal2;
      student1Tuition3 = tuition - student1DiscountTotal3;
      student1Tuition4 = tuition - student1DiscountTotal4;
      student1Tuition5 = tuition - student1DiscountTotal5;
      if (student1Tuition <= 0) {
        student1Tuition = 0;
        // $('.student2').fadeOut(350).prev('label').fadeOut(350);
      }

      $('.attendingSHG .student1').attr('data-value', student1Tuition1);
      $('.attendingSCGS .student1').attr('data-value', student1Tuition2);
      $('.employed .student1').attr('data-value', student1Tuition3);
      $('.paymentPlan .student1').attr('data-value', student1Tuition4);
      $('.income .student1').attr('data-value', student1Tuition5);

      student2DiscountTotal1 = student2Discount1;
      student2DiscountTotal2 = student2Discount1 + student2Discount2;
      student2DiscountTotal3 = student2Discount1 + student2Discount2 + student2Discount3;
      student2DiscountTotal4 = student2Discount1 + student2Discount2 + student2Discount3 + student2Discount4;
      student2DiscountTotal5 = student2Discount1 + student2Discount2 + student2Discount3 + student2Discount4 + student2Discount5;
      student2Tuition1 = tuition - student2DiscountTotal1;
      student2Tuition2 = tuition - student2DiscountTotal2;
      student2Tuition3 = tuition - student2DiscountTotal3;
      student2Tuition4 = tuition - student2DiscountTotal4;
      student2Tuition5 = tuition - student2DiscountTotal5;
      if (student2Tuition <= 0) {
        student2Tuition = 0;
        // $('.student2').fadeOut(350).prev('label').fadeOut(350);
      }

      $('.attendingSHG .student2').attr('data-value', student2Tuition1);
      $('.attendingSCGS .student2').attr('data-value', student2Tuition2);
      $('.employed .student2').attr('data-value', student2Tuition3);
      $('.paymentPlan .student2').attr('data-value', student2Tuition4);
      $('.income .student2').attr('data-value', student2Tuition5);

      student3DiscountTotal1 = student3Discount1;
      student3DiscountTotal2 = student3Discount1 + student3Discount2;
      student3DiscountTotal3 = student3Discount1 + student3Discount2 + student3Discount3;
      student3DiscountTotal4 = student3Discount1 + student3Discount2 + student3Discount3 + student3Discount4;
      student3DiscountTotal5 = student3Discount1 + student3Discount2 + student3Discount3 + student3Discount4 + student3Discount5;
      student3Tuition1 = tuition - student3DiscountTotal1;
      student3Tuition2 = tuition - student3DiscountTotal2;
      student3Tuition3 = tuition - student3DiscountTotal3;
      student3Tuition4 = tuition - student3DiscountTotal4;
      student3Tuition5 = tuition - student3DiscountTotal5;
      if (student3Tuition <= 0) {
        student3Tuition = 0;
        // $('.student2').fadeOut(350).prev('label').fadeOut(350);
      }

      $('.attendingSHG .student3').attr('data-value', student3Tuition1);
      $('.attendingSCGS .student3').attr('data-value', student3Tuition2);
      $('.employed .student3').attr('data-value', student3Tuition3);
      $('.paymentPlan .student3').attr('data-value', student3Tuition4);
      $('.income .student3').attr('data-value', student3Tuition5);

      student4DiscountTotal = student4Discount1 + student4Discount2 + student4Discount3 + student4Discount4 + student4Discount5;
      student4Tuition = tuition - student4DiscountTotal;
      if (student4Tuition <= 0) {
        student4Tuition = 0;
        // $('.student4').fadeOut(350).prev('label').fadeOut(350);
      }
      $('.student4').attr('data-value', student4Tuition);

      if (!$(this).closest('div').next('div').is(':visible')) {
        $(this).closest('div').addClass('completed').next('div').addClass('show').fadeIn(350);
      }
      students();
    });

    function students() {
      // $('input[name="student1"]').val(student1Tuition);
      // $('input[name="student2"]').val(student2Tuition);
      // $('input[name="student3"]').val(student3Tuition);
      // $('input[name="student4"]').val(student4Tuition);
      $('.student input[type="text"]').each(function () {
        var studentValue = $(this).attr('data-value');
        $(this).val('$' + parseFloat(studentValue, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').toString());
      });

    }
  }
  costCalculator();

  //View More for Alternative Accordions List
  $('.accordion-alt-item .read-more').click(function () {
    var $more = $(this).closest('.accordion-alt-item');
    var $toggletext = $(this).closest('.accordion-alt-item .read-more');

    if ($more.hasClass('expanded')) {
      $more.removeClass('expanded');
      $toggletext.html("View Course Details <span class='fas fa-caret-down'></span>");
    } else {
      $more.addClass('expanded');
      $toggletext.html("Hide Course Details <span class='fas fa-caret-up'></span>");
    }
  });

  $('.accordion-alt-item .read-more').on('keypress', function (e) {
    if (e.which === 13) {
      var $more = $(this).closest('.accordion-alt-item');
      var $toggletext = $(this).closest('.accordion-alt-item .read-more');

      if ($more.hasClass('expanded')) {
        $more.removeClass('expanded');
        $toggletext.html("View Course Details <span class='fas fa-caret-down'></span>");
      } else {
        $more.addClass('expanded');
        $toggletext.html("Hide Course Details <span class='fas fa-caret-up'></span>");
      }
    }
  });

  //Image Turning Effect
  $(".image-turning img").click(function () {
    $(".image-turning img.front-image").toggleClass('hidden').toggleClass('active');
    $(".image-turning img.back-image").toggleClass('active').toggleClass('hidden');
  });

  //Unwrap iframe from figure
  if ($('figure iframe').length) {
    $(this).unwrap();
  }

});

//Tables
$('#main').responsiveTables();